import { render, staticRenderFns } from "./SelectHeader.vue?vue&type=template&id=2c228d19&"
import script from "./SelectHeader.vue?vue&type=script&lang=ts&"
export * from "./SelectHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports